export const createSlug = (text) => {
    return text
    .toLowerCase()
    .replace(/[^\w\s]/gi, '')
    .replace(/\s+/g, '-')
    .replace(/-$/, '')
    .replace(/[-?]+/g, '-');
  };
